export default {"src":"/_next/static/media/whatsapp_icon.4c3d9a7b.svg","height":56,"width":56};